export default String.raw`

{% if products.FilteringOptions.PriceFrom != null and products.FilteringOptions.PriceFrom > 0 -%}
    {% assign priceFromExists = true -%}
{% endif -%}
{% if priceFromExists or products.FilteringOptions.PriceTo != null -%}
    {% assign pricesExist = true -%}
{% else -%}
    {% assign pricesExist = false -%}
{% endif -%}

{% if activeFiltersKeysString == "" or manufacturerOrBrandExists -%}
    {% assign showManufacturerOrBrand = true -%}
{% endif -%}

{% if products.HeaderData != null and showManufacturerOrBrand and pricesExist == false -%}
    {% if products.HeaderData.Image or products.HeaderData.Description != "" or products.HeaderData.Heading != "" -%}
        <div class="category-section-ui {% if products.HeaderData.Description != '' or products.HeaderData.Image -%} expandable-mechanism-container-js {% else -%} mb20-ui {% endif -%} {% if settings.graphFormOfNameDescImgCategory == 'left' -%} left-ui {% endif -%}">
            <div class="expand-data-js {% if products.HeaderData.Description != '' or products.HeaderData.Image -%} expandable-ui {% endif -%} {% if settings.categoryOpenedClosed == 'opened' -%} expanded-js {% endif -%}">
                <h1>
                    {% if products.HeaderData.Heading != "" -%}
                        {{products.HeaderData.Heading}}
                    {% else -%}
                        {{page.CurrentSiteNode.Name}}
                    {% endif -%}
                </h1>
                {% if products.HeaderData.Description != "" or products.HeaderData.Image -%}
                    <i class="ti-angle-down filter-arrow-ui dropdown-arrow"></i>
                {% endif -%}
            </div>
            {% if products.HeaderData.Description != "" or products.HeaderData.Image -%}
                {% if products.HeaderData.ImageId == 0 -%}
                    {% assign categoryImgUrl = products.HeaderData.Image.ExternalUrl -%}
                {% elseif products.HeaderData.ImageId > 0 -%}
                    {% capture categoryImgUrl -%}'img/{{products.HeaderData.ImageId}}/category-{{products.HeaderData.ImageId}}.jpg'{% endcapture -%}
                {% endif -%}
                <div class="category-img-ui expandable-ui expandable-js {% if settings.categoryOpenedClosed == 'opened' -%} expanded-js {% endif -%}">
                    <div class="category-img-js" {% if products.HeaderData.Image and settings.graphFormOfNameDescImgCategory == 'background' -%} style="background: url({{categoryImgUrl}}) no-repeat center; background-size: cover" {% endif -%}>
                        {% if products.HeaderData.Image and settings.graphFormOfNameDescImgCategory == "left" -%}
                            <div class="img-container-ui">
                                {{products.HeaderData|Img:'medium'}}
                            </div>
                        {% endif -%}
                        {% if products.HeaderData.Description != "" -%}
                            <div class="category-container-ui">
                                <div class="category-container-bg-ui">
                                    <div class="category-description-ui category-description-js">
                                        {{products.HeaderData.Description}}
                                        {% if products.HeaderData.AiGeneratedDescription -%}
                                            <div class="ai-generated-content">{{ translations.AiGeneratedDescription }}</div>
                                        {% endif -%}
                                    </div>
                                </div>
                            </div>
                        {% endif -%}
                    </div>
                </div>
            {% endif -%}
        </div>
    {% endif -%}
{% endif -%}
`